import React, { ButtonHTMLAttributes } from 'react';
import { cx } from './cx';

export const buttonVariants = ['primary', 'secondary', 'danger'] as const;
export const buttonSizes = ['small', 'medium', 'large'] as const;

export type ButtonVariant = (typeof buttonVariants)[number];
export type ButtonSize = (typeof buttonSizes)[number];

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
  children: React.ReactNode;
}

function variantClass(variant: ButtonVariant): string {
  switch (variant) {
    case 'primary':
      return 'osrs-btn--primary';
    case 'secondary':
      return 'osrs-btn--secondary';
    case 'danger':
      return 'osrs-btn--danger';
    default: {
      const neverVariant: never = variant;
      return neverVariant;
    }
  }
}

function sizeClass(size: ButtonSize): string {
  switch (size) {
    case 'small':
      return 'osrs-btn--small';
    case 'medium':
      return '';
    case 'large':
      return 'osrs-btn--large';
    default: {
      const neverSize: never = size;
      return neverSize;
    }
  }
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  children,
  className,
  type = 'button',
  ...props
}) => {
  return (
    <button
      type={type}
      className={cx(
        'osrs-btn',
        variantClass(variant),
        sizeClass(size),
        fullWidth && 'osrs-btn--full',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
